import {
  CompanyCreationDocument,
  CompanyCreationDocumentType,
} from '__generated__/GQL';

import { VerificationModuleData } from '../machine/model';

const getSelectedDocument = ({
  moduleData,
  selectedDocumentType,
}: {
  selectedDocumentType: CompanyCreationDocumentType | null;
  moduleData: VerificationModuleData;
}): CompanyCreationDocument | undefined => {
  return (
    moduleData.verificationData.viewer.company.companyCreationDocuments.find(
      (doc) => doc.type === selectedDocumentType,
    ) ?? undefined
  );
};

export default getSelectedDocument;
